import { useEffect } from 'react';

export const useTranscendScriptInject = () => {
  const { transcend } = CONFIG;

  useEffect(() => {
    if (!transcend.enabled) return;

    const existingScript = document.querySelector(`script[src="${transcend.scriptSrc}"]`);
    if (existingScript) return;

    const script = document.createElement('script');
    script.src = transcend.scriptSrc;
    script.setAttribute('data-cfasync', 'false');
    script.setAttribute('data-ui', `${transcend.baseURL}/ui.js`);
    script.setAttribute('data-css', `${transcend.baseURL}/cm_webapp.css`);
    script.setAttribute('data-messages', `${transcend.baseURL}/translations`);
    script.setAttribute('data-sync-endpoint', transcend.dataSyncEndpoint);

    document.head.appendChild(script);
  }, [transcend]);
};
